module.exports = __webpack_public_path__ + "static/media/8761.efab98aa.png";